var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.formValue,
        expression: "formValue"
      }
    ],
    staticClass: "c-checkbox__input",
    attrs: {
      name: _vm.formName,
      readonly: _vm.readonly,
      disabled: _vm.disabled,
      type: "checkbox"
    },
    domProps: {
      value: _vm.refValue,
      checked: Array.isArray(_vm.formValue)
        ? _vm._i(_vm.formValue, _vm.refValue) > -1
        : _vm.formValue
    },
    on: {
      change: function($event) {
        var $$a = _vm.formValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false
        if (Array.isArray($$a)) {
          var $$v = _vm.refValue,
            $$i = _vm._i($$a, $$v)
          if ($$el.checked) {
            $$i < 0 && (_vm.formValue = $$a.concat([$$v]))
          } else {
            $$i > -1 &&
              (_vm.formValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formValue = $$c
        }
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }